import React from 'react';

import { Header, IHeaderProps } from '../../modules/header';
import { IMainProps, Main } from '../../components/main';

export interface IViewBaseProps {
    children: React.ReactNode;
    header?: IHeaderProps;
    main?: IMainProps;
}

const renderHeader: (header: IHeaderProps) => JSX.Element = (header: IHeaderProps): JSX.Element => (
    <Header {...header} />
);

const ViewBase = (props: IViewBaseProps): JSX.Element => (
    <React.Fragment>
        {props.header && renderHeader(props.header)}
        <Main {...props.main}>
            {props.children}
        </Main>
    </React.Fragment>
);

export default ViewBase;
